import React from "react";
import { useTranslation } from "react-i18next";
import {withRouter} from "react-router-dom";

const Header =  withRouter((props) => {
  const { t } = useTranslation();
  const moveBack = () => {
    props.history.goBack();
  };

  return (
    <div className="header">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <h1 className="tit">
              {props.title || t("LC_02_04-GM.msg001")}
            </h1>
            <button className="btn-close-wrap" onClick={moveBack}>
              { props.buttonText || '닫기'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

});

export default Header;

